import React from "react";

export function CallHold() {
  return (
    <svg
      width="385"
      height="384"
      viewBox="0 0 385 384"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="CallHold">
        <g id="Frame">
          <g id="Group">
            <g id="Group 2">
              <g id="Group 3">
                <path
                  id="Vector"
                  d="M245.333 170.667H288C293.896 170.667 298.667 165.896 298.667 160V32C298.667 26.104 293.896 21.333 288 21.333H245.333C239.437 21.333 234.666 26.104 234.666 32V160C234.667 165.896 239.438 170.667 245.333 170.667ZM256 42.667H277.333V149.334H256V42.667Z"
                  fill="#D32F2F"
                />
                <path
                  id="Vector 2"
                  d="M373.333 21.333H330.666C324.771 21.333 320 26.104 320 32V160C320 165.896 324.771 170.667 330.667 170.667H373.334C379.23 170.667 384.001 165.896 384.001 160V32C384 26.104 379.229 21.333 373.333 21.333ZM362.667 149.333H341.334V42.667H362.667V149.333Z"
                  fill="#D32F2F"
                />
                <path
                  id="Vector 3"
                  d="M353.188 252.052C329.667 252.052 306.584 248.375 284.709 241.146C273.792 237.406 261.417 240.302 254.271 247.563L211.104 280.157C161.041 253.428 130.187 222.594 103.812 172.897L135.479 130.824C143.708 122.595 146.625 110.605 143.083 99.397C135.833 77.376 132.145 54.293 132.145 30.814C132.146 13.823 118.333 0 101.333 0H30.812C13.812 0 0 13.823 0 30.812C0 225.563 158.438 384 353.188 384C370.188 384 384.001 370.177 384.001 353.187V282.864C384 265.875 370.188 252.052 353.188 252.052ZM362.667 353.188C362.667 358.417 358.417 362.667 353.188 362.667C170.209 362.667 21.334 213.802 21.334 30.813C21.334 25.584 25.584 21.334 30.813 21.334H101.334C106.563 21.334 110.813 25.584 110.813 30.813C110.813 56.573 114.855 81.896 122.792 105.959C123.896 109.469 123 113.136 119.417 116.865L82.729 165.428C80.271 168.678 79.896 173.053 81.75 176.688C111.688 235.511 148.042 271.886 207.292 302.23C210.896 304.105 215.292 303.73 218.584 301.251L268.251 263.616C270.793 261.095 274.543 260.241 277.918 261.366C302.064 269.345 327.397 273.387 353.189 273.387C358.418 273.387 362.668 277.637 362.668 282.866V353.188H362.667Z"
                  fill="#D32F2F"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
